
<div class="filter-container">

  <!-- One filter - every criterion combines (e.g. Completed + Verified by X + Verified date range) -->
  <!-- A single line: User box | Date box | untitled box | Apply/Clear, all inside the Filters panel -->
  <div class="filter-group">
    <span class="group-label">Filters</span>

    <!-- The User box only exists for users who can filter by user (Supervisors) -->
    <div class="filter-box" *ngIf="canAssignProbates()">
      <span class="box-label">User</span>
      <mat-form-field appearance="outline" class="field-role">
        <mat-label>User is</mat-label>
        <mat-select [(value)]="userRole" [disabled]="!isUserRoleEnabled"
                    panelClass="filter-select-panel" panelWidth="">
          <mat-option *ngFor="let role of userRoleOptions" [value]="role.value">{{ role.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-user">
        <mat-label>User</mat-label>
        <mat-select [(value)]="selectedUserFilter" [compareWith]="compareUsers"
                    panelClass="filter-select-panel" panelWidth="">
          <mat-option [value]="null">All</mat-option>
          <mat-option value="unassigned">Unassigned</mat-option>
          <mat-option *ngFor="let user of users" [value]="user">{{ user.firstName }} {{ user.lastName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-box">
      <span class="box-label">Date</span>
      <!-- No mat-label - the box title says what it is -->
      <mat-form-field appearance="outline" class="field-datefield">
        <mat-select [(value)]="dateField" aria-label="Date field"
                    panelClass="filter-select-panel" panelWidth="">
          <mat-option *ngFor="let field of dateFieldOptions" [value]="field.value">{{ field.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-date">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" readonly (click)="startPicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-date">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" readonly (click)="endPicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
      <!-- Always shown (greyed out until there's a date to clear) so the line doesn't shift -->
      <button mat-icon-button class="clear-date-button" [disabled]="!(startDate || endDate)"
              (click)="clearDates()" matTooltip="Clear dates">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="filter-box">
      <mat-form-field appearance="outline" class="field-status">
        <mat-label>Status</mat-label>
        <mat-select multiple [(value)]="selectedStatusFilters"
                    [panelClass]="['status-filter-panel', 'filter-select-panel']" panelWidth="">
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-name">
        <mat-label>Deceased Name</mat-label>
        <input matInput [(ngModel)]="nameSearchValue" placeholder="Name contains..."
               (keyup.enter)="applyFilter()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-caseref">
        <mat-label>Case Ref</mat-label>
        <input matInput [(ngModel)]="probateSearchValue" placeholder="Exact ID"
               matTooltip="An exact case reference overrides every other filter"
               (keyup.enter)="applyFilter()">
      </mat-form-field>
      <mat-checkbox [(ngModel)]="showNonCharitable" class="noncharitable-checkbox">
        Show Non-Charitable
      </mat-checkbox>
    </div>

    <div class="filterSearchButton">
      <button mat-raised-button (click)="applyFilter()">Apply</button>
      <button mat-stroked-button class="clear-filters-button" (click)="clearFilters()">Clear</button>
    </div>
  </div>

  <div class="paginator">
    <mat-paginator [length]="totalCount"
                   [pageIndex]="pageIndex"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[50, 100, 200, 500]"
                   (page)="pageChanged($event)"
                   [selectConfig]="{ panelClass: 'filter-select-panel' }"
                   showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<!-- Selection summary - selection is kept across pages and sorts -->
<div class="selection-bar" *ngIf="selectedIds.size > 0 || canSelectAllMatching">
  <span *ngIf="selectedIds.size > 0">{{ selectedIds.size | number }} selected</span>
  <button *ngIf="canSelectAllMatching" mat-button class="selection-link" (click)="selectAllMatching()">
    Select all {{ totalCount | number }} matching
  </button>
  <button *ngIf="selectedIds.size > 0" mat-button class="selection-link" (click)="clearSelection()">
    Clear selection
  </button>
</div>

<div class="table-scroll-container">
<table mat-table [dataSource]="dataSource" matSort
       [matSortActive]="sortColumn" [matSortDirection]="sortDirection" (matSortChange)="sortChanged($event)"
       class="mat-elevation-z8">

  <!-- Selection Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="masterToggle()"
                    [checked]="isAllSelected()"
                    [indeterminate]="isSomeSelectedOnPage()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="toggleRow(row)"
                    [checked]="isRowSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- Case Reference Column (clickable) -->
  <ng-container matColumnDef="caseReferenceNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Ref</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'clickable-cell': true, 'selected-row': isRowSelected(element)}">
      <button mat-raised-button class="selectProbate-button" (click)="goToReport(element)">
        {{ element.probateId }}
      </button>
    </td>
  </ng-container>

  <!-- Other Columns -->
  <ng-container matColumnDef="fullNameOfDeceased">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.deceasedName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="clientCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.subscribedCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="nonClientCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Client Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.nonSubscribedCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="charitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.charitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="nonCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.nonCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dateOfIssue">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Probate</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.dateOfIssue | date: 'dd/MM/yyyy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="weekOld">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Week Old</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ getWeekOld(element.dateOfIssue) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="assignedUser">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned User</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.assignedUser?.firstName }} {{ element.assignedUser?.lastName }}
    </td>
  </ng-container>

  <!-- Reported By Column (Supervisors and System Administrators only) -->
  <ng-container matColumnDef="reportedBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Reported By</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.reportedByUser?.firstName }} {{ element.reportedByUser?.lastName }}
    </td>
  </ng-container>

  <!-- Verified By Column (Supervisors and System Administrators only) -->
  <ng-container matColumnDef="verifiedBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Verified By</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      {{ element.verifiedByUser?.firstName }} {{ element.verifiedByUser?.lastName }}
    </td>
  </ng-container>

  <!-- Has Notes Column -->
  <ng-container matColumnDef="hasNotes">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Has Notes</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      @if(element.noteCount > 0) {
        <span class="notes-trigger">
          <span class="has-notes-y">Y</span>
          <div class="notes-popover" (click)="$event.stopPropagation()">
            @for(n of element.notes; track n.id) {
              <div class="note-item">
                <div class="note-meta">{{ n.userDisplayName }} · {{ n.dateAdded | date:'dd/MM/yyyy HH:mm' }}</div>
                <div class="note-text">{{ n.textContent }}</div>
              </div>
            }
          </div>
        </span>
      } @else {
        <span>N</span>
      }
    </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': isRowSelected(element)}">
      <span class="status-badge status-{{ element.status }}">{{ getStatusLabel(element.status) }}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'selected-row': isRowSelected(row)}"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell no-records-cell" [attr.colspan]="displayedColumns.length">No Records Found</td>
  </tr>

</table>
</div>

<div *ngIf="canAssignProbates()" style="display: flex; justify-content: flex-end; padding-top: 12px; padding-right: 16px; flex-shrink: 0;">
  <mat-form-field appearance="outline" style="width: 200px; margin-right: 8px;">
    <mat-label>Assign To</mat-label>
    <mat-select [formControl]="assignToUserControl">
      <mat-option [value]="'unassign'">Unassign</mat-option>
      <mat-option *ngFor="let user of users" [value]="user">
        {{ user.firstName }} {{ user.lastName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-raised-button class="assign-button" (click)="assignSelectedProbates()"
          [disabled]="selectedIds.size === 0 || !assignToUserControl.value">
    Assign Selected{{ selectedIds.size > 0 ? ' (' + selectedIds.size + ')' : '' }}
  </button>
</div>
